import { Component, inject } from '@angular/core';
import { COMMON_IMPORTS } from '../../Shared/common-imports';
import { AuthService } from '../../Shared/Services/auth.service';
import { NavigationComponent } from '../../Navigation/navigation/navigation.component';
import { AvHeaderComponent } from '../../Shared/Components/av-header/av-header.component';
import { NavigationService } from '../../Navigation/Services/navigation.service';
import { AvFooterComponent } from '../../Shared/Components/av-footer/av-footer.component';

@Component({
  selector: 'app-workspace',
  standalone: true,
  imports: [...COMMON_IMPORTS, NavigationComponent, AvHeaderComponent, AvFooterComponent],
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.scss'],
})
export class WorkspaceComponent {
  mainNavService = inject(NavigationService);
  authService = inject(AuthService);
}
